export const actionTypePrefix = '@@watch';
export const reduxKey = '@@watch';

//# sourceMappingURL=constants.js.map